import React, { ReactNode } from 'react';

import { createContext, useContext } from 'use-context-selector';
import { ModalProductNotCovered } from '../components/ModalProductNotCovered';
import { ModalNineYearsDriveThru } from '../pages/ServiceTypePage/components/ModalNineYearsDriveThru';
import { ModalServiceUnavailable } from '../pages/ServiceTypePage/components/ModalServiceUnavailable';
import { gtmEvent } from '../utils/gtm';
import ModalNoEligibility from '../components/ModalNoEligibility';
import SystemUnavailable from '../components/SystemUnavailable';

export type ModalsContextProps = {
  openModal: (modal: keyof typeof Modals) => void;
};

type ModalsProviderProps = {
  children: ReactNode;
};

export enum Modals {
  PRODUCT_NOT_COVERED = 'PRODUCT_NOT_COVERED',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  NINE_YEARS_DRIVE_THRU = 'NINE_YEARS_DRIVE_THRU',
  NO_ELIGIBILITY = 'NO_ELIGIBILITY'
}

export const ModalsContext = createContext({} as ModalsContextProps);

export function ModalsProvider({ children }: ModalsProviderProps) {
  const [productNotCovered, setProductNotCovered] = React.useState(false);
  const [showModalServiceUnavailable, setShowModalServiceUnavailable] = React.useState(false);
  const [showModalNineYearsDriveThru, setModalNineYearsDriveThru] = React.useState(false);
  const [isModalNoEligibility, setIsModalNoEligibility] = React.useState(false);

  function openModal(modal: keyof typeof Modals) {
    const modals = {
      PRODUCT_NOT_COVERED: () => setProductNotCovered(true),
      SERVICE_UNAVAILABLE: () => setShowModalServiceUnavailable(true),
      NINE_YEARS_DRIVE_THRU: () => setModalNineYearsDriveThru(true),
      NO_ELIGIBILITY: () => setIsModalNoEligibility(true),
      DEFAULT: () => {}
    };
    modals[modal]();
  }

  return (
    <ModalsContext.Provider value={{ openModal }}>
      {children}
      <ModalProductNotCovered visible={productNotCovered} onClose={() => setProductNotCovered(false)} />
      <SystemUnavailable visible={showModalServiceUnavailable} onClose={() => setShowModalServiceUnavailable(false)} />
      <ModalNineYearsDriveThru
        visible={showModalNineYearsDriveThru}
        onClickClose={() => setModalNineYearsDriveThru(false)}
      />
      <ModalNoEligibility
        visible={isModalNoEligibility}
        onClose={() => {
          setIsModalNoEligibility(false);
        }}
      />
    </ModalsContext.Provider>
  );
}

export function useModalsContext() {
  return useContext(ModalsContext);
}
